import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ICONS } from './icons';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-icons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icons.component.html',
  styleUrls: ['./icons.component.scss'],
})
export class IconsComponent {
  @Input({ required: true }) name!: string;
  @Input() fillColor?: string;
  @Input() fillStroke?: string;
  @Input() strokeWidth?: string;
  @Input() width?: string;
  @Input() height?: string;
  @Input() isWithHover = false;
  private sanitizer = inject(DomSanitizer);

  // Define aquí tus SVGs como string
  private icons: { [key: string]: string } = ICONS;
  public theme$!: Observable<'light' | 'dark'>;

  getIcon(): SafeHtml {
    let icon =
      this.icons[this.name] ||
      '<svg><text x="0" y="15" fill="red">?</text></svg>';

    if (this.fillColor) {
      // Reemplazamos el valor del fill en el SVG con el color proporcionado
      icon = icon.replace(/fill="[^"]*"/g, `fill="${this.fillColor}"`);
      //También reemplazamos en el stroke para mantener consistencia
      icon = icon.replace(/stroke="[^"]*"/g, `stroke="${this.fillColor}"`);
    }
    if (this.fillStroke)
      icon = icon.replace(/stroke="[^"]*"/g, `stroke="${this.fillStroke}"`);
    if (this.strokeWidth) {
      icon = icon.replace(
        /stroke-width="[^"]*"/g,
        `stroke-width="${this.strokeWidth}"`,
      );
    }
    if (this.width) {
      icon = icon.replace(/width="[^"]*"/g, `width="${this.width}"`);
    }
    if (this.height) {
      icon = icon.replace(/height="[^"]*"/g, `height="${this.height}"`);
    }
    return this.sanitizer.bypassSecurityTrustHtml(icon);
  }
}
